import styled from 'styled-components'
import { components } from 'react-select'

import colors from 'components/utils/colors'
import { InnerComponent } from 'components/utils/innerReactSelectComponents'

import { StyledDropdownIndicator } from './DropdownIndicator'

const StyledControl = styled(InnerComponent).attrs({ Component: components.Control })`
  &.react-select__control {
    font-size: 14px;
    line-height: 16px;
    min-height: 16px;
    box-shadow: none;
    cursor: pointer;
    border-style: none;
    flex-wrap: nowrap;
  }

  .react-select__value-container {
    padding: 0 2px 0 0;
  }

  &:hover, &.react-select__control--menu-is-open {
    ${StyledDropdownIndicator} {
      color: ${colors.primary40};
    }
  }

  &.react-select__control--is-disabled {
    ${StyledDropdownIndicator} {
      display: none;
    }
    background-color: transparent;
  }
`

const SelectControl = (props) => {
  return (
    <StyledControl {...props} />
  )
}

export default SelectControl
